import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <Navbar bg="light" expand="lg" collapseOnSelect>
      <Container>
        <Navbar.Brand as={Link} to="/">Krayonika</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/">Главная</Nav.Link>
            <Nav.Link as={Link} to="/about">О студии</Nav.Link>
            <Nav.Link as={Link} to="/courses">Наши курсы</Nav.Link>
            <Nav.Link as={Link} to="/gallery">Галерея</Nav.Link>
            <Nav.Link as={Link} to="/projects">Проекты</Nav.Link>
            <Nav.Link as={Link} to="/contact">Контакты</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
